
export function endsWithMpegEtc(text){
    var splitDot = text.split('.');
    if (splitDot.length === 1){
    }else{
        var last = splitDot[splitDot.length - 1];
        if (last === 'mpeg' || last === 'mp3'){
            return true;
        }
    }
    return false;

}
export function urlHeaderStart(){
    return window.location.href.split('?')[0];
}

export function getRelevantLaunchInfo(history, programSetID){
  var relevantLaunchInfo;
  if (history && history !== 'loading'){
    for (var i = 0; i < history.length; i++){
      var aHistory = history[i];
      if (aHistory.v[0].v === programSetID){
        relevantLaunchInfo = aHistory;
      }
    }
  }
return relevantLaunchInfo;    
}

export function paramLine(urlParamsForPreview){
    if (urlParamsForPreview.length === 0){
      return '';
    }else{
      return '?' + urlParamsForPreview.map((aP, index)=>{return aP.i + '=' + aP.t}).join('&');
    }
  }

export function isInputTypeWithTooltip(inputType){
    return inputType === 'Text String' || inputType === 'Integer' || inputType === 'UInteger' || inputType === 'Decimal'        
}



export function checkIfIsTemplate(currentList){
  var mt = currentList.mt;
  if (mt && mt.o === '1'){
    return getFollowUp(mt).s;
  }
  return false;
}

export function getType(typeIn, currentList, path){
  if (typeIn.back !== undefined){
    var parent = goDownPath(currentList, path, typeIn.back);
    var here = goDownPath(parent, typeIn.fwd);
    if (!here){
      return {t:'toDelete'};
    }else{
      return convertSelectionToType(here, currentList);
    }
  }else{
    return typeIn;
  }
}

export function getContractInfo(currentList, aContractKey){
  var contracts = currentList.sc;
  var aContract = contracts[aContractKey];
  if (aContract){
    var addSet = aContract.addSet;
    var addSetKeys = Object.keys(addSet);
    return addSet[addSetKeys[0]];
  }
  return false;
}

export function getAbiFnInfo(abi, stakeFn, needExact){
    if (stakeFn && (typeof stakeFn === 'string' || stakeFn instanceof String)){
        var stakeFnParts = stakeFn.split(' ');
        for (var i = 0; i < abi.length; i++){
            var thisAbi = abi[i];
            if (thisAbi && thisAbi.name){
                if ((thisAbi.name === stakeFnParts[0]) || (!needExact && thisAbi.name.indexOf(stakeFnParts[0]))){
                    if (stakeFnParts[1] === undefined || stakeFnParts[1] === null || thisAbi.inputs.length === +stakeFnParts[1]){
                        return thisAbi;
                    } 
                }
            }
        }
    }else{
        return abi[+stakeFn];
    }
    return false;
}

export function getContractInfoAbi(currentList, aContractKey){
    var info = getContractInfo(currentList, aContractKey)
    if (info){
        return getAbiFromContractInfo(info);
    }
    return false;
}

export function getAbiFromContractInfo(info){
    if (info.proxy){
        return JSON.parse(info.proxy.abi);
    }
    return JSON.parse(info.abi);
}
export function getCodeFromContractInfo(info){
    if (info.proxy){
        return info.proxy.code;
    }
    return info.code;
}


export function getFollowUp(thisAction){
if (!thisAction.c){
    return thisAction[thisAction.p];
}
  return  thisAction.c[thisAction.o];
}

export function isAdmin(logInState){
    return logInState && logInState.t === 'email' && (logInState.v === 'cuesshared@gmail.com'  || logInState.v === 'sturtle107@gmail.com');
    // return logInState && logInState.t === 'email' && (logInState.v === 'cuesshared@gmail.com');
}

export function filterPathStopBefore(pathDown, stopBefore){
    return pathDown.filter((aP,index)=>{
      return +index < stopBefore;
    })

}


export function iconFromType(type){
    if (type.t === 'Text String'){ return 'bx:text'
    }else if (type.t === 'Integer'){ return 'carbon:character-integer'
    }else if (type.t === 'UInteger'){ return 'mdi:numeric-positive-1'
    }else if (type.t === 'Boolean'){ return 'radix-icons:component-boolean'
    }else if (type.t === 'Address'){ return 'cil:address-book'
    }else if (type.t === 'Date Time'){ return 'bi:calendar-date';
    }else if (type.t === 'Decimal'){ return 'mdi:decimal';
    }else if (type.t === 'Conditional'){ return 'carbon:list-dropdown';
    }else if (type.t === 'Action'){ return 'icon-park-outline:effects';
    }else if (type.t === 'Condition'){ return 'carbon:decision-tree';
    }else if (type.t === 'List'){ return 'ant-design:unordered-list-outlined';
    }else if (type.t === 'ListType'){ return 'ant-design:unordered-list-outlined';
    }else if (type.t === 'Object'){ return 'ic:baseline-data-object';
    }else if (type.t === 'Variable'){ return 'fluent:braces-variable-24-filled';
    }else if (type.t === 'Coin'){ return 'akar-icons:coin';
    }else if (type.t === 'NFT'){ return 'arcticons:coin-flip';
    }else if (type.t === 'Type'){ return 'carbon:type-pattern';
    }else if (type.t === 'Mapping'){ return 'akar-icons:map';
    }else if (type.t === 'Enum'){return 'akar-icons:book-open';
    }else if (type.t === 'Event'){return 'bi:broadcast-pin';
    }else if (type.t === 'MerkleRoot'){return 'cil:address-book';
    }else if (type.t === 'MerkleProof'){return 'bi:tree-fill';
    }else if (type.t === 'Struct'){return 'ic:baseline-data-object';
    }else if (type.t === 'IPFS'){return 'akar-icons:image';
    }else if (type.t === 'GoDown'){return 'carbon:microscope';
    }else if (type.t === 'None'){return 'mdi:border-none-variant';
    }else if (type.t === 'Transaction'){return 'icon-park-outline:transaction';
    }else{
        console.warn(type);
    }
}

export function convertSelectionToType(obj, currentList){
    if (obj.i === 'ListType'){
        return {t:'ListType', c:convertSelectionToType(obj.subs.t, currentList)};
    }else if (obj.i === 'Struct'){
        var os = currentList.os;
        if (obj.subs && obj.subs.st && obj.subs.st.i){
            var thisV = obj.subs.st.i
            var thisOs = os[thisV];
            if (thisOs){
              var subs = thisOs.s;
              var subKeys = sortedKeyList(subs);
              var c = subKeys.map((aSubKey, index)=>{
                var aSub = subs[aSubKey];
                return {keyOnce:aSubKey, n:aSub.n, t:convertSelectionToType(aSub.t, currentList)}; //n is the main reference. key is here just so that we can create the initial values for ownVariables. otherwise we don't use key.
              })
              return {t:'Object', c};
            }
        }
        return {t:'toDelete'}
    }else if (obj.i === 'Date Time'){
        return {t:'UInteger', sp:'dateTime'};
    }else{
        return {t:obj.i};
    }
}

export function clearSelection(){
    var sel = document.getSelection();
    sel.removeAllRanges();
}

export function justDirectFormulaNoSubsequent(at){
    return at === 'gi' || at === 'scr' || at === 'mus' || at === 'coin' || at === 'curr' || at === 's' || at === 'i'  || at === 'ui' || at === 'dc' || at === 'ad' || at === 'ca' || at === 'dt' || at === 'pu';
}
export function directV(at){
    return at === 'f' || justDirectFormulaNoSubsequent(at);
}

export function withP(typeT){
    return typeT === 'gV' || typeT === 'aC' || typeT === 'm' || typeT === 'oVar' || typeT === 'inP'
}
export function stringifyIfObject(x){

    if (typeof x === 'object'){
        return JSON.stringify(x);
    }else{
        return x;
    }
}

export function gotTextX(tt){
    return tt === 'DIV'  || tt === 'ALERT' || tt === 'SUMMARYDIV'
}
export function simplName(uuid){
    var x = uuid.substr(uuid.length - 3);

    var regex3 = /^[0-9]/
    if (regex3){
        return 'a' + x;
    }
    return x;
}

export function isHolder(tt) {
     // || tt === 'GALLERY' 
    return (tt === 'CARD' || tt === 'HFLEX' || tt === 'SUMMARY' || tt === 'CONTAINER' || tt === 'TABLE' || tt === 'TR' || tt === 'TD' || tt === 'TABS' || tt === 'TABITEM' || tt === 'navDropDown'|| tt === 'RADIO');
}
export function coins(){
  return [{t:'Bitcoin', i:'bitcoin'}, {t:'Ethereum', i:'ethereum'}];
}

export function currencies(){
    return [{t:'US Dollar', i:'usd'}, {t:'Euro', i:'eur'}, {t:'British Pounds', i:'gbp'}, {t:'Hong Kong Dollar', i:'hkd'}, {t:'Singapore Dollar', i:'sgd'}, {t:'Bitcoin', i:'btc'}, {t:'Ethereum', i:'eth'}, {t:'Binance', i:'bnb'}, {t:'Litecoin', i:'ltc'}, {t:'Bitcoin Cash', i:'bch'}, {t:'EOS', i:'eos'}, {t:'XRP', i:'xrp'}, {t:'Stellar', i:'xlm'}, {t:'Chainlink', i:'link'}, {t:'Polkadot', i:'dot'}, {t:'Yearn Finance', i:'yfi'}];
}


export function getElementInfo(anItem){
    if (anItem === 'BUTTON'){
      return {t:'Button', n:'c', i:'mdi:gesture-tap-button', h:'Interactive element, activated via a click.'};
    }else if (anItem === 'navLink'){
      return {t:'Link', n:'c', i:'akar-icons:link-out', h:'Link to another part of page'};
    }else if (anItem === 'navDropDown'){
      return {t:'Dropdown', n:'c', i:'carbon:list-dropdown', h:'Opens a sub-menu'};
    }else if (anItem === 'navBrand'){
      return {t:'Brand', n:'c', i:'icons8:header', h:'Header Text/Logo'};
    }else if (anItem === 'INPUT'){
      return {t:'Input', n:'c', i:'iconoir:input-field', h:'Collect information from users'};
    }else if (anItem === 'GALLERY'){
      return {t:'Gallery', n:'c', i:'dashicons:format-gallery', h:'Expandable Picture Gallery'};
    }else if (anItem === 'HR'){
      return {t:'Line Break', n:'c', i:'ant-design:line-outlined', h:'Horizontal Line'};
    }else if (anItem === 'GALLERYITEM'){
      return {t:'Gallery Items', n:'c', i:'dashicons:format-gallery', h:'Gallery Items (this row is never shown)'};
    }else if (anItem === 'TIMER'){
      return {t:'Timer', n:'c', i:'carbon:timer', h:'Count time until / since an event'};
    }else if (anItem === 'SPACE'){
      return {t:'Space', n:'c', i:'cil:space-bar', h:'Used to add space within a row.'};
    }else if (anItem === 'CARD'){
      return {t:'Card', n:'d', i:'icon-park-outline:id-card-v', h:'Content containers, usually with a border & padding around its content'};
    }else if (anItem === 'RADIO'){
        return {t:'Choices', n:'c', i:'majesticons:radio-list', h:'Select from a set of items'}
    }else if (anItem === 'SUMMARYDIV'){
      return {t:'Summary Item', n:'d', i:'icon-park-outline:add-item', h:'Additional Description in the Summary Box'};
    }else if (anItem === 'SUMMARY'){
      return {t:'Summary', n:'d', i:'material-symbols:dynamic-form-outline', h:'When the summary is clicked, the originally hidden details content will become visible. Suitable for FAQs.'};
    }else if (anItem === 'ALERT'){
      return {t:'Banner', n:'d', i:'fluent:window-header-horizontal-20-filled', h:'Banners for messages, such as alerts'};
    }else if (anItem === 'CONTAINER'){
      return {t:'Container', n:'l', i:'pixelarticons:section', h:'Basic layout element'};
    }else if (anItem === 'HFLEX'){
      return {t:'Row', n:'l', i:'material-symbols:table-rows-outline', h:'Wrappers for columns.'};
    }else if (anItem === 'navBar'){
      return {t:'Nav Bar', n:'l', i:'bi:menu-button-wide-fill', h:'Aid visitors to access information.'};
    }else if (anItem === 'IMG'){
        return {t:'Image', i:'bi:image', n:'c', h:'Add a picture'};
    }else if (anItem === 'DIV'){
        return {t:'Text', n:'c', i:'fluent:textbox-24-regular', h:'Add plain and/or rich texts'};
    }else if (anItem === 'VIDEO'){
        return {t:'Video', n:'c', i:'ant-design:video-camera-outlined', h:'Youtube video'}
    }else if (anItem === 'ICON'){
        return {t:'Icon', n:'c', i:'arcticons:lawnicons', h:'Icon'}
    }else if (anItem === 'FOOTER'){
        return {t:'Footer', n:'l', i:'fluent:document-footer-16-regular', h:'Common Footer across all pages'}
    }else if (anItem === 'PANEL'){
        return {t:'Panel', n:'l', i:'carbon:open-panel-filled-top', h:'Regular Panel to add elements'}
    }else if (anItem === 'TABLE'){
        return {t:'Table', n:'l', i:'bi:table', h:'Regular Table to display rows and columns'}
    }else if (anItem === 'TR'){
        return {t:'Table Row', n:'l', i:'fluent:table-insert-row-16-filled', h:'Add a Row to the Table'}
    }else if (anItem === 'TD'){
        return {t:'Table Cell', n:'l', i:'jam:table-cell', h:'Add a Cell to the Row'}
    }else if (anItem === 'LINECHART'){
        return {t:'Line', n:'ch', i:'ant-design:line-chart-outlined', h:'Display time-based data'}
    }else if (anItem === 'BARCHART'){
        return {t:'Bar', n:'ch', i:'ant-design:bar-chart-outlined', h:'Show quantities for different groups'}
    }else if (anItem === 'PIECHART'){
        return {t:'Pie', n:'ch', i:'ant-design:pie-chart-outlined', h:'Display proportions'}
    }else if (anItem === 'TABS'){
        return {t:'Tabs', n:'l', i:'ph:tabs-fill', h:'All contents to be shown when users click on a tab'}
    }else if (anItem === 'TABITEM'){
        return {t:'A Tab', n:'c', i:'fluent:tab-desktop-16-regular', h:'Add a tab'}
    }else if (anItem === 'SPAN'){
        return {t:'Rich Text', n:'', i:'bx:text'}
    }else if (anItem === 'Page'){
        return {t:'Page', n:'', i:'bx:text'}
    }else if (anItem === 'Pop-Up'){
        return {t:'Pop-Up', n:'', i:'bx:text'}
    }else if (anItem === 'fe'){
        return {t:'Page', n:'', i:'bx:text'}
    }else if (anItem === 'pu'){
        return {t:'Pop-Up', n:'', i:'bx:text'}
    }else{
      console.warn(anItem);
      return 'xxx';
    }    
}

export function replaceSpansInSomething(item, currentList, userNos){
    var iItems = [];
    var i = item.i;
    if (i){
      var iKeys = Object.keys(i);
      iKeys.forEach((anIKey, index)=>{
        var toCheck = replaceSpansInSomething(i[anIKey], currentList, userNos);
        iItems = iItems.concat(toCheck);
      })
    }
    var k = item.k;
    if (k){
      var kKeys = Object.keys(k);
      kKeys.forEach((anIKey, index)=>{
        var toCheck = replaceSpansInSomething(k[anIKey], currentList, userNos);
        iItems = iItems.concat(toCheck);
      })
    }
    var al = item.al;
    if (al){
      var alKeys = Object.keys(al);
      alKeys.forEach((anIKey, index)=>{
        var toCheck = replaceSpansInSomething(al[anIKey], currentList, userNos);
        iItems = iItems.concat(toCheck);
      })
    }
    var x = item.x;
    if (x){
      x.forEach((anX, index)=>{
        if (anX.t === 't' || anX.t === 'h' || anX.t === 'br'){
        }else if (anX.t === 'a'){
          var uuid = uuidScoped(userNos, currentList, ['as'], []); 
          var oldPieceClean = JSON.parse(JSON.stringify(currentList.as[anX.i]));  
          iItems.push({t:'w',w:['as',uuid],n:oldPieceClean});
          anX.i = uuid;
        }else{
          console.warn(anX);
        }
      })
    }

    return iItems;
}

export  function checkPathGotError(thisPath, errorString){
    var thisPathString = thisPath.join(' ');
    if (errorString){
      if (errorString.indexOf(thisPathString) === 0){
        return true;
      }
    }
    return false;    
  }

export function getStartFE(currentList){
    var fe = currentList.fe;
    var ss = currentList._g.ss;
    if (fe[ss]){
        return ss;
    }else{
        var feKeys = Object.keys(fe);
        if (feKeys.length > 0){
            return feKeys[0];
        }
    }
    return '';
}

export function goDownPath(input, path, subtract){
  if (!subtract){
    subtract = 0;
  }
  for (var i = 0; i < path.length - subtract; i++){
    input = input[path[i]];
  }
  return input;
}

export function relevantChainId(currentList){
    return goDownPath(currentList, ['_g', 'curr', 'o'], 0);
}

export function nameOfAnApp(currentList, appID){
    return currentList.fe[appID]._na;
}

export function sortedKeyList(ii){
    function compare(a, b) {
    if (ii[a].ord < ii[b].ord) {
      return -1;
    }
    if (ii[a].ord > ii[b].ord) {
      return 1;
    }

    if (a < b){
      return - 1;
    }else if (b > a){
      return 1;
    }
    // a must be equal to b
    return 0;
    }

    var kk = Object.keys(ii);
    return kk.sort(compare);

}

export function chainNameFromId(id, chains){
    return getRelevantChain(id, chains).n1;
}

//this bsc thing is tricky. bsc has 18 digits like all evms, but the bnb coin (presumably on eth) has 8 digits.

export function networks(chainID, cc){
    for (var i = 0; i < cc.length; i++){
        var thisChain = cc[i];
        if (thisChain.ci === chainID){
            return {
                chainId: `0x${Number(chainID).toString(16)}`,
                chainName: thisChain.n,
                nativeCurrency: {
                  name: thisChain.c,
                  symbol: thisChain.i,
                  decimals: 18
                },
                rpcUrls: thisChain.r,
                blockExplorerUrls: thisChain.b
              }
        }
    }


};


export function getChainDAppIsOn(currentList){
    if (currentList){
        if (currentList.t){
            return currentList.curr.o;
        }else{
            return currentList._g.curr.o;
        }
    }  
    return 0;
}

export function currencyOfDatabase(currentList, chains){
    return chainNameFromId(getChainDAppIsOn(currentList), chains);
}

export function currencySymbolOfDatabase(currentList, chains){
    return getRelevantChain(getChainDAppIsOn(currentList), chains).c;
}

export function filterPathDown(pathDown, i){
    return pathDown.filter((aP, index1)=>{
        return +index1 < i;
    })
}

export function isAlert(objPath){
  if (objPath[4] === 'al' && objPath.length === 6){
    return true;
  }
  return false;
  // {t:'objectName', i:'item'}
}


function tempUuidv4(){
    return 'xxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
            let r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }
    );
}

export function uuidScoped(userNos, currentList, scope, possibleConflicts){
    var anAttempt = 'c'+userNos + '_' + tempUuidv4();
    var thisPath = goDownPath(currentList, scope, 0);
    if (thisPath){
        if (thisPath[anAttempt] || possibleConflicts.includes(anAttempt)){
            return uuidScoped(userNos, currentList, scope, possibleConflicts);
        }
    }
    return anAttempt;
}

export function uuidCheckEverywhere(userNos, currentList){
    var anAttempt = 'c'+userNos + '_' + tempUuidv4();
    var repeated = findItemWithKey(anAttempt, currentList);
    if (repeated){
        return uuidCheckEverywhere(userNos, currentList);
    }else{
        return anAttempt;
    }
}

function findItemWithKey(anAttempt, aList){
    if (aList instanceof Object){
        var keys = Object.keys(aList);
        for (var i = 0; i < keys.length; i++){
            var thisItem = aList[keys[i]];
            if (keys[i] === anAttempt){
                return thisItem;
            }
            var p = findItemWithKey(anAttempt, thisItem);
            if (p){
                return p;
            }
        }
        return false;
    }else{
        return false;
    }
}

export function convertToStrings(item, type){
    if (type.t === 'UInteger' || type.t === 'Integer' || type.t === 'Date Time' || type.t === 'Date'){
        return item.toString();
    }else if (type.t === 'Text String' ){
        return item;
    }else if (type.t === 'toDelete'){
        return 'toDelete';
    }else{
        console.warn(item);
        console.warn(type);
    }
}

export function getInfoFromChains(currency, tgt, chains){
    var c = getRelevantChain(currency, chains);
    if (c){
        return c[tgt];
    }        
}

export function getRelevantChain(chainId, allChains){
    for (var i1 = 0; i1 < allChains.length; i1++){
        if (allChains[i1].ci === chainId){
            return allChains[i1];
        }
    }
    return false;

}

export function errorString(error){
    if (error){
        if (error.loc){
            return error.loc.join(' ');
        }
    }
    return [];
}

export function squeezeIn(elements, selection, objPath){
    var anchorNode = selection.anchorNode;
    var anchorOffset = selection.anchorOffset;

    if (!anchorNode.tagName){
      var beforeText = anchorNode.textContent.substr(0, anchorOffset);
      var afterText = anchorNode.textContent.substr(anchorOffset);
      anchorNode.textContent = afterText;
      var beforePieceSet = drillUpToNodeWithText(beforeText, anchorNode);
      var beforePiece = beforePieceSet.basic;
      var newAnchorNode = beforePieceSet.sibling;
      if (newAnchorNode === false){
        var edit3 = document.getElementById('editor' + objPath.join('_'));
        elements.forEach((ele, index)=>{
          edit3.appendChild(ele);
        });
      }else{
        newAnchorNode.parentNode.insertBefore(beforePiece, newAnchorNode);
        elements.forEach((ele, index)=>{
          newAnchorNode.parentNode.insertBefore(ele, newAnchorNode);
        })

      }
    }else{
      var relevantChild = anchorNode.childNodes[anchorOffset];
      elements.forEach((ele, index)=>{
        anchorNode.insertBefore(ele, relevantChild);
      });
    }
}

    function drillUpToNodeWithText(afterText, copyFromNode){
      var basic = document.createTextNode(afterText);

      function seeAbove(node){
        var parent = node.parentNode;
        if (!parent){
          return false;
        }else if (parent.tagName === 'DIV' || parent.tagName === 'TD'){
          return node;
        }else if (parent.tagName === 'B' || parent.tagName === 'U' || parent.tagName === 'I'){
          var createPiece = document.createElement(parent.tagName);
          createPiece.appendChild(basic);
          basic = createPiece;
          return seeAbove(parent);
        }else if (parent.tagName === 'SPAN' || parent.tagName === 'FONT'){
          if (parent.id){
            return node;
          }else{
            var style = parent.style;
            var createPiece2 = document.createElement('SPAN');
            for (var i = 0; i < 100;  i++){
                var canStyle = style[i.toString()];
                if (canStyle){
                    createPiece2.style[canStyle] = style[canStyle];
                }else{
                    break;
                }
            }
            createPiece2.appendChild(basic);
            basic = createPiece2;
            return seeAbove(parent);
          }
        }else{
          console.warn(parent);
        }
      }
      var sibling = seeAbove(copyFromNode);
      return {basic, sibling}
    }